<div style="display: flex; flex-direction: row;justify-content:space-between;">
  <div class="rfq-create-form" style="display: flex; flex-direction: column;overflow-x: hidden;">
      <div class="rfq-create-form-title">

          <div style="display: flex;flex-direction:row;justify-content:space-between;margin-top:10px;margin-bottom:5px">
              <div id="createquotation">
                View Service Purchase Order
              </div>
              <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
          </div>
      </div>

      <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">
          <mat-card class="p-0" style="margin: 0 0.5rem">
              <mat-card-content class="ship-fscoll hgt ship-pr-sec">
                  <nav mat-tab-nav-bar class="tagGroup">
                      <a mat-tab-link *ngFor="let tabItem of tabs; let idx = index"
                          [class.active-link]="currentTab === tabItem.route" class="teb_icon"
                          (click)="selectMatTabLink(tabItem)">
                          <span id="navstepstext">{{tabItem.label}}</span>
                      </a>
                  </nav>

                  <div #pdfContent style="width:100%;">

                      <div>
                          <div style="display: flex; flex-direction: column; overflow-x: auto; width: 100%;margin-top:70px">

                              <form [formGroup]="lineItemTableForm">

                                <ngx-datatable
                                  #table
                                  class="material expandable"
                                  [rows]="dataSource"
                                  [headerHeight]="50"
                                  [footerHeight]="50"
                                  [rowHeight]="'auto'"
                                  [columnMode]="'force'"
                                  [scrollbarH]="true"
                                  [externalPaging]="false"
                                  [externalSorting]="false"
                                  [limit]="10"
                                  >

                                  <ngx-datatable-column name="S.No." [width]="100">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'position')" readonly style="width: 40px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Name">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'serviceName')" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Service Description">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'serviceDescription')"
                                        [disabled]="true" readonly></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Buyer Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'buyerComment')"
                                        [disabled]="true" readonly></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Supplier Comment">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <textarea matInput [formControl]="getRowControl(rowIndex, 'supplierComment')"
                                        readonly></textarea>
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'quantity')"
                                        [disabled]="true" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Quantity">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'supplierQuantity')"
                                        readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Requested UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'uom')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted UOM">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input matInput [formControl]="getRowControl(rowIndex, 'supplierUom')" readonly style="width: 100px;" />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Unit Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput
                                        [formControl]="getRowControl(rowIndex, 'unitCost')"
                                        [disabled]="true" step="any"
                                        readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Discount">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput
                                        [formControl]="getRowControl(rowIndex, 'discount')"
                                        [disabled]="true" step="any"
                                        readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Quoted Total Cost">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput
                                        [formControl]="getRowControl(rowIndex, 'totalCost')"
                                        [disabled]="true" step="any" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                  <ngx-datatable-column name="Lead Time">
                                    <ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                      <input type="number" matInput [formControl]="getRowControl(rowIndex, 'leadTime')" style="width: 100px;" readonly />
                                    </ng-template>
                                  </ngx-datatable-column>

                                </ngx-datatable>
                              </form>

                          </div>
                          <div class="secondformcontainerfull" style="margin: 30px;float:right;">
                            <form [formGroup]="costSummaryFormGroup">
                              <div class="floating-card-container">
                                <div class="floating-card">
                                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 20px; font-weight: bold;">
                                    <span><b>Total <span *ngIf="costSummaryFormGroup.get('currency')?.value?.currencyCode !== null">
                                      ({{ costSummaryFormGroup.get('currency')?.value?.currencyCode}})
                                    </span></b></span>
                                    <span>{{ (costSummaryFormGroup.get('lineItemTotal')?.value || 0) | number: '1.3-3' }}</span>
                                  </div>
                                  <div class="card-body mx-4">
                                     <div class="container">

                                        <div class="row">
                                          <hr>
                                          <div class="col-xl-10">
                                            <p>Line Item list Price Sub Total</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'lineItemListPriceSubtotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p>Line Item Discount</p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'lineItemDiscount'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <div class="col-xl-10">
                                            <p><b>Line Item Sub Total</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'lineItemSubtotal'" [disabled]="true" step="any" readonly />

                                            </p>
                                          </div>
                                          <hr>
                                        </div>
                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>General Discount</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <select formControlName="generalDiscountType" [disabled]="true" readonly style="width: 100%; margin-bottom: 10px;">
                                                <option value="percentage">Percentage</option>
                                                </select>
                                              <input type="number" matInput [formControlName]="'generalDiscountValue'"  step="any" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-10">
                                            <p><b>Applicable Tax Profile</b></p>
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input type="number" matInput [formControlName]="'lineItemTaxAmount'"  step="any" readonly/>

                                            </p>
                                          </div>
                                          <hr>
                                        </div>

                                        <div class="row">
                                          <div class="col-xl-12" *ngIf="costSummaryFormGroup.get('quoteLineItemFreight')?.value?.length > 0">
                                            <div
                                              *ngFor="let item of costSummaryFormGroup.get('quoteLineItemFreight')?.value"
                                              class="d-flex align-items-center justify-content-between mb-2"
                                            >
                                              <label class="fw-bold me-2" style="min-width: 100px;">
                                                {{ item.freightDescription }}
                                              </label>

                                              <div class="freight-wrapper">
                                                <input
                                                  type="text"
                                                  matInput
                                                  [value]="item.freightValue | number : '1.3-3'"
                                                  readonly
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="col-xl-10">
                                          </div>
                                          <div class="col-xl-2">
                                            <p class="float-end">
                                              <input
                                                type="number"
                                                matInput
                                                [formControlName]="'lineItemFreightTotal'"
                                                step="any"
                                                readonly
                                              />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;" />
                                        </div>
                                        <div class="row text-black">

                                          <div class="col-xl-12">
                                            <p class="float-end fw-bold" style="color: white !important;"> Total:
                                              <input type="number" matInput [formControlName]="'lineItemTotal'" [disabled]="true" step="any" readonly />
                                            </p>
                                          </div>
                                          <hr style="border: 1px solid white;">
                                        </div>


                                      </div>
                                  </div>
                                </div>
                              </div>
                        </form>
                        </div>

                      </div>

                  </div>
                  <div style="width:100%;">

                            <form [formGroup]="headerFormGroup">
                            <div>

                                <!-- Purchase Order Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form1')">
                                    Purchase Order Details
                                    <mat-icon>{{ isForm1Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm1Expand" class="three-column-flex">

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Number</mat-label>
                                        <input matInput formControlName="purchaseOrderRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Date</mat-label>
                                        <input matInput [matDatepicker]="poDate" formControlName="purchaseOrderDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="poDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #poDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Ref Number</mat-label>
                                        <input matInput formControlName="rfqRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Date</mat-label>
                                        <input matInput [matDatepicker]="rfqDate" formControlName="rfqDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="rfqDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #rfqDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quote Ref Number</mat-label>
                                        <input matInput formControlName="quoteRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quotation Date</mat-label>
                                        <input matInput [matDatepicker]="quotationDate" formControlName="quotationDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="quotationDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #quotationDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Expected Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="expectedDeliveryDate" formControlName="expectedDeliveryDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="expectedDeliveryDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #expectedDeliveryDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Company Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form2')">
                                    Buyer Company Details
                                    <mat-icon>{{ isForm2Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm2Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Buyer Name</mat-label>
                                        <input matInput formControlName="buyerCompanyName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form3')">
                                    Buyer Details
                                    <mat-icon>{{ isForm3Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm3Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Contact Person (Job Title)</mat-label>
                                        <input matInput formControlName="buyerContactPerson" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerContactEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerContactPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerContactFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerContactAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Supplier Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form4')">
                                    Supplier Details
                                    <mat-icon>{{ isForm4Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm4Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Supplier Contact Name</mat-label>
                                        <input matInput formControlName="supplierContactName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="supplierEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="supplierPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="supplierFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Company Email</mat-label>
                                        <input matInput formControlName="supplierCompanyEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Vessel Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form5')">
                                    Vessel Details
                                    <mat-icon>{{ isForm5Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm5Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Name</mat-label>
                                        <input matInput formControlName="vesselName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel IMO Number</mat-label>
                                        <input matInput formControlName="vesselIMONumber" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Type</mat-label>
                                        <input matInput formControlName="vesselType" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Class</mat-label>
                                        <input matInput formControlName="vesselClass" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Port Details -->
                                <div class="header-form-header">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form6')">
                                    Port Details
                                    <mat-icon>{{ isForm6Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm6Expand" class="three-column-flex">
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Name</mat-label>
                                        <input matInput formControlName="portName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Code</mat-label>
                                        <input matInput formControlName="portCode" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETA</mat-label>
                                        <input matInput [matDatepicker]="vesselETA" formControlName="vesselETA" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETA" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETA></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row-header">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETD</mat-label>
                                        <input matInput [matDatepicker]="vesselETD" formControlName="vesselETD" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="vesselETD" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETD></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </form>

                  </div>
                  <div style="width:100%;">
                    <form [formGroup]="paymentFormGroup">
                        <!-- Buyer Payment Terms -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form7')"
                        >
                            Buyer Payment Terms
                            <mat-icon>{{
                            isForm7Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm7Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Billing Address</mat-label>
                                <input matInput formControlName="billingAddress" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Applicable Tax Profile</mat-label>
                                <input
                                matInput
                                formControlName="applicableTaxProfile"
                                readonly
                                />
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Buyers Payment Terms</mat-label>
                                <input matInput formControlName="buyersPaymentTerms" readonly/>
                            </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3;flex: 0 0 63.2%;margin-top:20px;">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Conditions</mat-label>
                                <textarea
                                matInput
                                formControlName="buyerTermsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>

                        <!-- Port Agent Details -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form8')"
                        >
                            Port Agent Details
                            <mat-icon>{{
                            isForm8Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm8Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agency Name</mat-label>
                                  <input matInput formControlName="portAgencyName" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Name</mat-label>
                                  <input matInput formControlName="portAgentName" readonly />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Number</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentPhoneNumber"
                                  readonly
                                  />
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Contact</mat-label>
                                  <input matInput formControlName="portAgentContact" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Port Agent Phone Fax</mat-label>
                                  <input matInput formControlName="portAgentPhoneFax" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Email ID</mat-label>
                                  <input matInput formControlName="portAgentEmail" readonly/>
                              </mat-form-field>
                            </div>
                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                  <mat-label>Address</mat-label>
                                  <input
                                  matInput
                                  formControlName="portAgentAddress"
                                  readonly
                                  >
                              </mat-form-field>
                            </div>
                        </div>
                      </div>


                        <div class="header-form-header">
                          <span
                            style="
                              padding-left: 16px;
                              padding-top: 16px;
                              margin-bottom: 32px;
                              font-weight: bold;
                              display: flex;
                              justify-content: space-between;
                              padding-right: 20px;
                            "
                            (click)="toggleVisibility('form9')"
                          >
                            Freight Forwarder Details
                            <mat-icon>{{ isForm9Expand ? "minimize" : "add" }}</mat-icon>
                          </span>

                          <div *ngIf="isForm9Expand" class="three-column-flex">
                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Freight Forwarder Company Name</mat-label>
                                <input matInput formControlName="freightCompanyName" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>PIC</mat-label>
                                <input matInput formControlName="freightPIC" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Job Title</mat-label>
                                <input matInput formControlName="freightJobTitle" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Email ID</mat-label>
                                <input matInput formControlName="freightEmail" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Phone</mat-label>
                                <input matInput formControlName="freightPhone" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Fax</mat-label>
                                <input matInput formControlName="freightFax" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header" style="grid-column: span 3">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Address</mat-label>
                                <input matInput formControlName="freightAddress" readonly />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Packaging</mat-label>
                                <input
                                  matInput
                                  formControlName="freightPackaging"
                                  [matTooltip]="paymentFormGroup.get('freightPackaging')?.value"
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                  readonly
                                />
                              </mat-form-field>
                            </div>

                            <div class="form-item-row-header">
                              <mat-form-field class="full-width" color="accent">
                                <mat-label>Mode of Transport</mat-label>
                                <input
                                  matInput
                                  formControlName="freightTransportMode"
                                  readonly
                                  [matTooltip]="paymentFormGroup.get('freightTransportMode')?.value"
                                  matTooltipPosition="above"
                                  matTooltipShowDelay="500"
                                  readonly
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        </div>


                        <!-- Terms and Conditions -->
                        <div class="header-form-header">
                        <span
                            style="
                            padding-left: 16px;
                            padding-top: 16px;
                            margin-bottom: 32px;
                            font-weight: bold;
                            display: flex;
                            justify-content: space-between;
                            padding-right: 20px;
                            "
                            (click)="toggleVisibility('form10')"
                        >
                            Terms and Conditions
                            <mat-icon>{{
                            isForm10Expand ? "minimize" : "add"
                            }}</mat-icon>
                        </span>

                        <div *ngIf="isForm10Expand" class="three-column-flex">
                            <div class="form-item-row-header" style="grid-column: span 3;margin-top:20px">
                            <mat-form-field class="full-width" color="accent">
                                <mat-label>Terms and Condition</mat-label>
                                <textarea
                                matInput
                                formControlName="termsAndConditions"
                                readonly
                                ></textarea>
                            </mat-form-field>
                            </div>



                            <div class="form-item-row-header">
                            <div class="file-name-box">
                                {{
                                getHeaderAttachmentCount() === 0
                                    ? "No files chosen"
                                    : getHeaderAttachmentCount() === 1
                                    ? "1 file chosen"
                                    : getHeaderAttachmentCount() + " files chosen"
                                }}
                                <button
                                    mat-icon-button
                                    *ngIf="getHeaderAttachmentCount() > 0"
                                    (click)="togglePreview(true, 'generalAttachment')"
                                    type="button"
                                >
                                    <mat-icon>visibility</mat-icon>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </form>
                  </div>
                  <div style="width:100%;display: flex;justify-content: center;align-items: center;margin-top:20px">
                    <button class="right-button" (click)="save(true)" style="background-color: #FF8900;">
                       Save as Draft
                    </button>
                  </div>
              </mat-card-content>
          </mat-card>
      </div>
  </div>




    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <p class="mb-6">You want to save this as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>

        </div>
    </div>
</div>


<div
  class="blur"
  *ngIf="previewSection"
  (click)="togglePreview(false, '')"
></div>

<div class="carousel-container" *ngIf="previewSection">
  <!-- Close Button -->
  <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePreview(false, '')">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>

  <!-- Carousel Content -->
  <div class="carousel">
    <!-- Previous Button -->
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <!-- Image/PDF Preview -->
    <div class="carousel-image-container">
      <ng-container *ngIf="previewDoc[currentIndex]">
        <div
          class="carousel-preview-inner"
          *ngIf="isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <pdf-viewer
            [src]="previewDoc[currentIndex].dataUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="pdf-content"
          ></pdf-viewer>
        </div>

        <div
          class="carousel-preview-inner"
          *ngIf="!isPdf(previewDoc[currentIndex]?.dataUrl)"
        >
          <img
            [src]="previewDoc[currentIndex]?.dataUrl"
            alt="attachment image"
            class="carousel-image"
          />
        </div>
      </ng-container>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>
